import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const tenantTermGroupsRoutes = [
  {
    path: 'term-groups',
    component: () => import('@/features/superAdmin/tenantTermGroups/TenantTermGroups.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.TermGroupsView,
    },
  },
  {
    path: 'term-groups/:id',
    component: () => import('@/features/superAdmin/tenantTermGroups/TenantTermGroupDetail.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.TermGroupsView,
    },
  },
]
